const configs = {
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:4010',
};

export default configs;
